export const pluralize = (word: string, times: number) =>
  `${word}${times === 0 || times > 1 ? 's' : ''}`;
